// vue
import { ref } from '@vue/composition-api';
import { useStore } from '@/store';

// hooks
import { useAxios } from '@/vue3/hooks/axiosHook';

// models
import { AdminDashboardSummary } from '@/vue3/api/models/adminDashboardModels';

export const useAdminDashboardService = () => {
    // hooks
    const store = useStore();
    const axios = useAxios();

    // properties
    const url = store.state.apiUrl;

    // methods
    const getAllAdminSummary = async (): Promise<AdminDashboardSummary> => {
        const res = await axios.get(`${url}/admin/summary`);
        return res.data;
    };

    return {
        getAllAdminSummary,
    };
};
